import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "b4e06d7d-3efb-4009-b1f6-2b9cb3b743a3", content: "ITD", options: {} },
  { id: "98142f1f-6e73-4ff7-92f6-3c13c87be733", content: "spectral cues", options: {} },
  { id: "f40adf71-c632-4ec9-b7d0-04bcc565390e", content: "head movements", options: {} },
  { id: "5bd7a2a2-693b-40ca-afab-d26b93939d29", content: "ILD", options: {} },
  { id: "f77ffb4c-96fc-4af0-9cd4-80cf65cf3ba5", content: "IPD", options: {} },
  {
    id: "c75c0718-3b32-4050-aaca-d51973c1ed6a",
    content: "localization is impossible in the median plane",
    options: {},
  },
];

export const task: Task = {
  id: "f4c6a33d-c63a-4c3f-9e58-d43532fbe16b",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["98142f1f-6e73-4ff7-92f6-3c13c87be733", "f40adf71-c632-4ec9-b7d0-04bcc565390e"],
};
